import { forwardRef, Ref, useMemo, useState } from 'react'

import { Option } from '@hhgtech/hhg-components/build/components/molecules/dropdown'
import { LocaleType } from '@hhgtech/hhg-components/build/interfaces/types'
import { useRouter } from 'next/router'
import { useIntl } from 'react-intl'

import { LOCALE_SPECS } from 'interfaces/constants'

import {
  StyledDropdown,
  StyledInput,
  StyledPhoneInputWrapper,
} from './index.styled'

type PhoneInputProps = {
  onChangeCode: (data: Option) => void
  className?: string
  defaultValue?: { countryPhoneCode?: string; phone?: string }
  required?: boolean
}

const countryPhoneOptions = (Object.keys(LOCALE_SPECS) as LocaleType[])
  .filter((e) => e !== 'tl-PH')
  .map((key) => ({
    value: LOCALE_SPECS[key]?.PHONE,
    label: `(${LOCALE_SPECS[key]?.PHONE})`,
    icon: <img src={LOCALE_SPECS[key]?.FLAG} alt="" loading="lazy" />,
  }))

export const PhoneInput = forwardRef(function PhoneInput(
  { onChangeCode, className, defaultValue, required }: PhoneInputProps,
  ref: Ref<HTMLInputElement>,
) {
  const { formatMessage: f } = useIntl()
  const { locale = 'en-PH' } = useRouter()
  const countryPhoneOptionsByLocale = useMemo(
    () =>
      countryPhoneOptions.sort((a) =>
        a.value === LOCALE_SPECS[locale].PHONE ? -1 : 1,
      ),
    [countryPhoneOptions, locale],
  )
  const [countryPhoneCode, setCountryPhoneCode] = useState<Option>(
    defaultValue?.countryPhoneCode
      ? countryPhoneOptionsByLocale.find(
          (option) => option.value === defaultValue.countryPhoneCode,
        ) || countryPhoneOptionsByLocale[0]
      : countryPhoneOptionsByLocale[0],
  )
  return (
    <StyledPhoneInputWrapper className={className}>
      <StyledDropdown
        id="country-phone-code"
        value={countryPhoneCode}
        options={countryPhoneOptionsByLocale}
        placeholderIcon={countryPhoneCode.icon}
        placeholder=""
        onChange={(option) => {
          setCountryPhoneCode(option)
          onChangeCode(option)
        }}
      />
      <StyledInput
        ref={ref}
        placeholder={f({
          id: 'common.input.phone.placeholder',
          defaultMessage: 'Phone number',
        })}
        type="tel"
        name="phone"
        defaultValue={defaultValue?.phone}
        required={required}
        pattern="[0-9]{9}|[0-9]{10}"
      />
    </StyledPhoneInputWrapper>
  )
})
